import { Box } from '@mui/material'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 32px;
`
